// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Top Participants`
};

const de_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Top Teilnehmer`
};

const es_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Mejores Participantes`
};

const fr_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Meilleurs participants`
};

const fi_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Parhaat Osallistujat`
};

const hi_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `शीर्ष प्रतिभागी`
};

const ja_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `上位参加者`
};

const nl_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Top Deelnemers`
};

const pt_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Melhores Participantes`
};

const ro_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Participanții de Top`
};

const th_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `ผู้เข้าร่วมอันดับต้น`
};

const ur_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `ٹاپ شرکاء`
};

const zh_hant1_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `頂級參與者`
};

const da_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Top Deltagere`
};

const it_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Migliori Partecipanti`
};

const vn_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Người tham gia hàng đầu`
};

const ko_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `상위 참가자`
};

const tr_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `En İyi Katılımcılar`
};

const lv_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Labākie Dalībnieki`
};

const ar_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `أفضل المشاركين`
};

const bs_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Najbolji učesnici`
};

const sl_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Najboljši udeleženci`
};

const id_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Peserta Teratas`
};

const sv_widget_leaderboard_top_participants = /** @type {(inputs: {}) => string} */ () => {
	return `Toppar deltagare`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_leaderboard_top_participants = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_leaderboard_top_participants(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_leaderboard_top_participants", locale)
	if (locale === "en") return en_widget_leaderboard_top_participants(inputs)
	if (locale === "de") return de_widget_leaderboard_top_participants(inputs)
	if (locale === "es") return es_widget_leaderboard_top_participants(inputs)
	if (locale === "fr") return fr_widget_leaderboard_top_participants(inputs)
	if (locale === "fi") return fi_widget_leaderboard_top_participants(inputs)
	if (locale === "hi") return hi_widget_leaderboard_top_participants(inputs)
	if (locale === "ja") return ja_widget_leaderboard_top_participants(inputs)
	if (locale === "nl") return nl_widget_leaderboard_top_participants(inputs)
	if (locale === "pt") return pt_widget_leaderboard_top_participants(inputs)
	if (locale === "ro") return ro_widget_leaderboard_top_participants(inputs)
	if (locale === "th") return th_widget_leaderboard_top_participants(inputs)
	if (locale === "ur") return ur_widget_leaderboard_top_participants(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_leaderboard_top_participants(inputs)
	if (locale === "da") return da_widget_leaderboard_top_participants(inputs)
	if (locale === "it") return it_widget_leaderboard_top_participants(inputs)
	if (locale === "vn") return vn_widget_leaderboard_top_participants(inputs)
	if (locale === "ko") return ko_widget_leaderboard_top_participants(inputs)
	if (locale === "tr") return tr_widget_leaderboard_top_participants(inputs)
	if (locale === "lv") return lv_widget_leaderboard_top_participants(inputs)
	if (locale === "ar") return ar_widget_leaderboard_top_participants(inputs)
	if (locale === "bs") return bs_widget_leaderboard_top_participants(inputs)
	if (locale === "sl") return sl_widget_leaderboard_top_participants(inputs)
	if (locale === "id") return id_widget_leaderboard_top_participants(inputs)
	if (locale === "sv") return sv_widget_leaderboard_top_participants(inputs)
	return "widget_leaderboard_top_participants"
};